import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import sslService from "../../services/ssl.service";
import API from "../../configs/axiosInstance";

export const getSsl = createAsyncThunk("ssl/getSsl", async (data,{
    dispatch
}) => {
    try {
        const response = await  sslService.getSsl(null, data?.data);
        dispatch(setFilterRequest(data));
        return response
    } catch (error) {
    }
});

export const exportCertificatesExcel = createAsyncThunk(
    'ssl/exportCertificatesExcel',
    async (_, { rejectWithValue }) => {
        try {
            const response = await sslService.exportCertificatesExcel();
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const getSslDetails = createAsyncThunk("ssl/getSslDetails", async ( data,{
    rejectWithValue
}) => {
    try {
        return await sslService.getSslDetails(data);
    } catch (error) {
        return rejectWithValue(error);
    }
});

const initialState = {
    sslList : [],
    sslDetail : null,
    tableLoading: false,
    filterRequest: {},

    exportCertificatesLoading: false,
    exportCertificates: null,

    defaultFilterRequest: {
        data: {
            domain: "",
            portNumber: null,
            validFrom: "",
            validTo: "",
            type: "DOMAIN",
        },
        params: {
            page: 0,
            size: 5
        }

    }
};

export const sslSlice = createSlice({
    name: 'sslSlice',
    initialState,
    reducers: {
        setFilterRequest: (state, action) => {
            state.filterRequest = action.payload;
        },

    },
    extraReducers: (builder) => {
        builder.addCase(getSsl.fulfilled, (state, action) => {
            state.sslList = action.payload.data;
            state.tableLoading = false;
        });

        builder.addCase(getSsl.pending, (state, action) => {
            state.tableLoading = true;
        });

        builder.addCase(getSsl.rejected, (state, action) => {
            state.tableLoading = false;
        });
        builder.addCase(getSslDetails.fulfilled, (state, action) => {
            state.sslDetail = action.payload.data;
            state.tableLoading = false;
        });

        builder.addCase(getSslDetails.pending, (state, action) => {
            state.sslDetail = null;
            state.tableLoading = true;
        });

        builder.addCase(getSslDetails.rejected, (state, action) => {
            state.tableLoading = false;
        });
        builder.addCase(exportCertificatesExcel.pending, (state) => {
            state.exportCertificatesLoading = true;
        });
        builder.addCase(exportCertificatesExcel.fulfilled, (state, action) => {
            state.exportCertificatesLoading = false;
            state.exportCertificates = action.payload;
        });
        builder.addCase(exportCertificatesExcel.rejected, (state) => {
            state.exportCertificatesLoading = false;
        });
    }
});

export const {
    setSslData,
    setFilterRequest,
} = sslSlice.actions;

export default sslSlice.reducer;

